import { SVGProps } from "react";

export const IconSearch: React.FunctionComponent<SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.44447 9.88888C7.89908 9.88888 9.88894 7.89903 9.88894 5.44444C9.88894 2.98984 7.89908 1 5.44447 1C2.98986 1 1 2.98984 1 5.44444C1 7.89903 2.98986 9.88888 5.44447 9.88888Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M11.0002 11.0002L8.5835 8.5835"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
};
